<div class="suppliers-header d-flex align-items-center justify-content-between mb-4" *transloco="let t; prefix: 'suppliers'">
  <h1 class="title mb-0">{{ t('title') }}</h1>
  <div class="header-actions d-flex gap-2">
    <app-account-filter [filter]="accountFilter" (filterChanged)="onAccountFilterChange($event)"> </app-account-filter>
    <app-search [placeholder]="t('search.placeholder')" [disabled]="isLoading" (searchTermUpdated)="onSearchTermUpdate($event)">
    </app-search>
    <span ngbDropdown class="filter-dropdown" [autoClose]="true">
      <button
        type="button"
        class="btn category-filter form-control dropdown-toggle filter-input"
        [disabled]="isLoading || isCategoriesLoading"
        id="categoryFilterDropdown"
        ngbDropdownToggle>
        <div class="d-flex flex-row justify-content-between align-items-center">
          <span class="align-middle">{{ isCategoriesLoading ? t('filters.loadingCategories') : selectedCategory }}</span>
          <i class="ph ph-caret-down lh-base"></i>
        </div>
      </button>
      <div ngbDropdownMenu aria-labelledby="categoryFilterDropdown" class="dropdown-menu-custom">
        <button class="btn btn-outline dropdown-item-custom" (click)="onClearCategoryFilter()" ngbDropdownItem type="button">
          {{ t('filters.allCategories') }}
        </button>
        @for (category of categories; track category) {
          <button class="btn btn-outline dropdown-item-custom" (click)="onCategoryFilterChange(category)" ngbDropdownItem type="button">
            {{ category.name }}
          </button>
        }
      </div>
    </span>
    <button type="button" class="btn add-supplier-btn" (click)="openUpsertSupplierModal()">
      <span>{{ t('actions.addSupplier') }}</span>
    </button>
  </div>
</div>

<div class="suppliers-layout" *transloco="let t; prefix: 'suppliers'">
  <div class="table-wrapper table-section">
    <div class="main-table suppliers-overview" #tableContainer>
      <table class="table">
        <thead>
          <tr>
            <th class="supplier" [class.active]="sortColumn === 'name'"> {{ t('table.supplier') }}
              <button class="sort-button" (click)="sortByColumn('name')">
                <i class="ph ph-arrows-down-up"></i>
              </button>
            </th>
            <th class="category" [class.active]="sortColumn === 'categoryName'"> {{ t('table.category') }}
              <button class="sort-button" (click)="sortByColumn('categoryName')">
                <i class="ph ph-arrows-down-up"></i>
              </button>
            </th>
            <th class="contact-person" [class.active]="sortColumn === 'contactPerson'"> {{ t('table.contactPerson') }}
              <button class="sort-button" (click)="sortByColumn('contactPerson')">
                <i class="ph ph-arrows-down-up"></i>
              </button>
            </th>
            <th class="last-order-cost" [class.active]="sortColumn === 'lastOrderCost'">{{ t('table.lastOrderCost') }}
              <button class="sort-button" (click)="sortByColumn('lastOrderCost')">
                <i class="ph ph-arrows-down-up"></i>
              </button>
            </th>
            <th class="last-order-qty" [class.active]="sortColumn === 'lastOrderQuantity'">{{ t('table.lastOrderQty') }}
              <button class="sort-button" (click)="sortByColumn('lastOrderQuantity')">
                <i class="ph ph-arrows-down-up"></i>
              </button>
            </th>
            <th class="actions">{{ t('table.actions') }}</th>
          </tr>
        </thead>

        @if (isLoading) {
          <tbody class="spinner-container d-flex align-items-center justify-content-center">
            <div class="spinner-border" role="status"></div>
          </tbody>
        } @else {
          <tbody>
            @for (item of suppliers; track item.id) {
              <tr>
                <td class="supplier">
                  <p class="supplier-name">{{ item.name }}</p>
                </td>
                <td class="category">
                  <p>{{ item.categoryName }}</p>
                </td>
                <td class="contact-person">
                  <p class="contact-name">{{ item.contactPerson }}</p>
                  <p class="contact-email">{{ item.email }}</p>
                </td>
                <td class="last-order-cost">
                  <p>{{ currencyFormat(item.lastOrderCost) ?? '-' }}</p>
                </td>
                <td class="last-order-qty">
                  <p>{{ item.lastOrderQuantity ?? '-' }}</p>
                </td>
                <td class="actions">
                  <div ngbDropdown class="action-dropdown" placement="bottom-end">
                    <button class="btn btn-link action-btn" ngbDropdownToggle [attr.aria-label]="t('table.actionsFor', { name: item.name })">
                      <i class="ph ph-dots-three-vertical"></i>
                    </button>
                    <div ngbDropdownMenu class="dropdown-menu">
                      <button ngbDropdownItem (click)="onEditClick(item, $event)">{{ t('actions.edit') }}</button>
                      <button ngbDropdownItem class="text-danger" (click)="onDeleteClick(item, $event)">{{ t('actions.delete') }}</button>
                    </div>
                  </div>
                </td>
              </tr>
            }
            @if (!isLoading && suppliers.length === 0) {
              <tr class="no-data-row">
                <td colspan="6">
                  <div class="table__no-data">
                    <span>{{ t('noSuppliersFound') }}</span>
                  </div>
                </td>
              </tr>
            }
          </tbody>
        }
      </table>
    </div>

    <div class="bottom-options d-flex justify-content-between align-items-center">
      <div class="showing-text">{{ getShowingText() }}</div>

      <app-pagination [totalPages]="totalPages" [currentPage]="currentPage" (pageChange)="onPageChange($event)"> </app-pagination>

      <app-export
        [request]="getExportRequest()"
        [disabled]="isLoading"
        [filePrefix]="'Suppliers'"
        [endpoint]="'suppliers'">
      </app-export>
    </div>
  </div>

  <!--<div class="sidebar-section">
    <app-ai-supplier-optimization></app-ai-supplier-optimization>
  </div>-->
</div>